const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @utilities
const { getPublicSitePathByLanguaje } = require('core/apiURLBuilder');

//@Actions
const actionTypes = require('constants/actionTypes');

const getURLRequest = (dgsCode) => {
    return {
        type: actionTypes.BROKER_MORNINGSTAR_URL_PLANS_REQUEST,
        payload: {
            dgsCode
        }
    };
};

const getURLSuccess = (dgsCode, response) => {
    return {
        type: actionTypes.BROKER_MORNINGSTAR_URL_PLANS_SUCCESS,
        payload: {
            data: response,
            dgsCode
        }
    };
};

const getURLFailure = (response) => {
    return {
        type: actionTypes.BROKER_MORNINGSTAR_URL_PLANS_FAILURE,
        payload: {
            data: response
        }
    };
};

const getDgsCodeToSecIDURL = (dgsCode) => (dispatch) => {

    dispatch(getURLRequest(dgsCode));

    return APIGet(dispatch, apiURLBuilder.getURL('morningstarPlansDgsCodeToSecID', {dgsCode: dgsCode}))
        .then(response => {
            window.location.replace(getPublicSitePathByLanguaje('brokerURL-brokerURL_pensionPlanOnPublic', { isin: dgsCode }));
            dispatch(getURLSuccess(dgsCode, response));
    }, response => {
            dispatch(getURLFailure(response));
        }
    );
};

module.exports = {
    getDgsCodeToSecIDURL
};
